import * as React from 'react';
import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { classes, st } from './ErrorMessageWrapper.st.css';
import {
  ErrorAppearance,
  ErrorMessageWrapperDataHooks,
  ErrorMessageWrapperProps,
} from './types';

export const ErrorMessageWrapper = ({
  className,
  children,
  visible = false,
  suffixText,
  'data-hook': dataHook,
  messageId,
  message,
  errorAppearance = ErrorAppearance.TextOnly,
  lang,
}: ErrorMessageWrapperProps) => {
  const getMessage = () => {
    return (
      <div
        id={messageId}
        className={classes.message}
        data-hook={ErrorMessageWrapperDataHooks.Message}
      >
        <ErrorSmall className={classes.icon} aria-hidden />
        {message}
      </div>
    );
  };

  return (
    <div
      className={st(classes.root, { visible, errorAppearance }, className)}
      data-hook={dataHook}
      lang={lang}
    >
      {children}
      {visible &&
        (suffixText ? (
          <div className={classes.messageWithSuffix}>
            {getMessage()}
            {suffixText}
          </div>
        ) : (
          getMessage()
        ))}
    </div>
  );
};
